module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-30.8df82f87.svg";